var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "oversea-bill-detail",
      attrs: {
        id: "app",
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_InternationalBill"),
        fullscreen: "",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          style:
            "min-width: 1600px;" +
            (_vm.expandedGrid || !_vm.showBillForm
              ? "height: 100%;display: flex;flex-direction: column;"
              : "")
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.expandedGrid,
                  expression: "!expandedGrid"
                }
              ],
              staticClass: "app-main-inner-row oversea-bill-detail-form-wrapper"
            },
            [
              _vm.showBillForm
                ? _c("bill-form", {
                    attrs: {
                      billing: _vm.billing,
                      "billing-form-params": _vm.billingFormParams,
                      "is-view": true,
                      "request-source": _vm.requestSource
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "justify-content": "center", "font-size": "30px" }
            },
            [
              _c("i", {
                class: _vm.expandedGrid
                  ? "el-icon-caret-bottom"
                  : "el-icon-caret-top",
                on: {
                  click: function($event) {
                    _vm.expandedGrid = !_vm.expandedGrid
                  }
                }
              })
            ]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "justify-content": "space-between" }
            },
            [_c("div")]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "justify-content": "space-between" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isView,
                      expression: "isView"
                    }
                  ],
                  staticClass: "section"
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "reconciliationMode" },
                      on: { change: _vm.reconciliationTypeChangeHandler },
                      model: {
                        value: _vm.reconciliationType,
                        callback: function($$v) {
                          _vm.reconciliationType = $$v
                        },
                        expression: "reconciliationType"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { no: "viewedByJob", label: "job" } },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ViewedByJob")))]
                      ),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { no: "viewedByFee", label: "charge" }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ViewedByFee")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              style:
                _vm.expandedGrid || !_vm.showBillForm
                  ? "flex-grow: 1;"
                  : "height:300px"
            },
            [
              _c("cargo-ag-grid", {
                style: { width: "100%", height: "auto" },
                attrs: {
                  "config-module":
                    _vm.reconciliationType === "job" ? "1301253" : "1301252",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["button_billTab_invoiceFromBilling"],
                  expression: "['button_billTab_invoiceFromBilling']"
                }
              ],
              attrs: { disabled: _vm.applyInvoiceDisabled, type: "primary" },
              on: {
                click: function($event) {
                  return _vm.onApplyInvoiceClick(_vm.billing)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Billing.ApplyForInvoicing")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }